export default __webpack_public_path__ + "static/media/DG_Block_Logo.c7e0ee5c.svg";